import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createBasket, updateBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { signIn } from '@store/guest/actions';
import { yourJourneySelectors } from '@store/yourJourney';
import { SpaTreatmentDetailV2 } from './SpaTreatmentDetailV2';

const mapStateToProps = (state: any) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  basketGuests: basketSelectors.getBasketGuests(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
      signIn,
    },
    dispatch
  );

export const SpaTreatmentDetailV2Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaTreatmentDetailV2);
